import * as moment from "moment";
import { Appointment } from "../models/appointment.model";
import { Doctor } from "../models/doctor.model";
import { Expert } from "../models/expert.model";
import { AdminNote } from "../models/forms/admin-note.model";
import { AppointmentLog } from "../models/log.model";
import { OrgLocation } from "../models/org-location.model";
import { Organization } from "../models/organization.model";
import { Patient } from "../models/patient.model";
import { RelevantLab } from "../models/relevant-lab.model";
import { Specialty } from "../models/specialty.model";
import { SubSpecialty } from "../models/sub-specialty.model";

export function createAppointment(appointment) {
    let newAppointment = new Appointment;
    newAppointment = { ...appointment }
    return newAppointment;
}

export function createAppointmentObject(appointment) {
    let newAppointment = { ...appointment }
    newAppointment.appointment_date = appointment.appointment_date != null && appointment.appointment_date != '' ? moment(appointment.appointment_date).format().toString() : '';
    newAppointment.appointment_date_timestamp = appointment.appointment_date != null && appointment.appointment_date != '' ? moment(appointment.appointment_date).format('x').toString() : '';
    return newAppointment;
}

export function createDoctor(doctor) {
    let newDoctor = new Doctor();
    newDoctor = {
        ...doctor,
        email: doctor.email.toLowerCase().trim()
    }
    return newDoctor;
}

export function createDoctorObject(doctor) {
    let newDoctor = {
        ...doctor,
        email: doctor.email.toLowerCase().trim(),
        first_name: doctor.first_name.toLowerCase().trim(),
        last_name: doctor.last_name.toLowerCase().trim(),
        user_id: doctor.user_id || doctor.id || ''
    };
    return newDoctor;
}

export function createExpert(expert) {
    let newExpert = new Expert();
    newExpert = {
        ...expert,
        email: expert.email.toLowerCase().trim(),
        first_name: expert.first_name.toLowerCase().trim(),
        last_name: expert.last_name.toLowerCase().trim(),
        date_of_birth: moment(expert.date_of_birth).format('DD MMM YYYY').toString() || '',
        specialty: expert.specialty_list || expert.specialty,
        created_at: moment(expert.created_at).format('DD MMM YYYY').toString() || '',
        updated_at: moment(expert.updated_at).format('DD MMM YYYY').toString() || '',
        invited_on: moment(expert.invited_on, 'x').format('DD MMM YYYY').toString() || '',
    };

    return newExpert;
}

export function createExpertObject(expert) {
    let newExpert = { ...expert }
    newExpert.first_name = expert.first_name.toLowerCase().trim();
    newExpert.last_name = expert.last_name.toLowerCase().trim();
    newExpert.email = expert.email.toLowerCase().trim();

    return newExpert;
}

export function createNewExpertObject(expert) {
    let newExpert = { ...expert };
    newExpert.email = expert.email.toLowerCase().trim();
    newExpert.first_name = expert.first_name.toLowerCase().trim();
    newExpert.last_name = expert.last_name.toLowerCase().trim();
    newExpert.date_of_birth = moment(expert.date_of_birth).format('YYYY-MM-DD').toString();
    return newExpert;
}


export function createNewExpertSpecialtyObject(expertID: string, specialty: Specialty, subSpecialty: SubSpecialty) {
    const newExpertSpecialty = {
        expert_id: expertID,
        specialty: specialty.specialty_name,
        specialty_id: specialty.id,
        sub_specialty: subSpecialty.sub_specialty_name,
        sub_specialty_id: subSpecialty.id,
        general_sub_specialty: subSpecialty.general_sub_specialty
    }

    return newExpertSpecialty;
}

export function createPatient(patient: any): Patient {
    let newPatient = new Patient();
    newPatient = { ...patient };
    newPatient.email = patient.email.toLowerCase().trim();
    return newPatient;
}

export function createPatientObject(patient): any {
    let newPatient = { ...patient };
    newPatient.first_name = patient.first_name.toLowerCase().trim();
    newPatient.last_name = patient.last_name.toLowerCase().trim();
    newPatient.date_of_birth = moment(patient.date_of_birth).format('MM-DD-YYYY').toString();
    newPatient.email = patient.email.toLowerCase().trim();
    return newPatient;
}

export function createNewPatientObject(patient): any {
    let newPatient = {
        first_name: patient.first_name.toLowerCase().trim(),
        last_name: patient.last_name.toLowerCase().trim(),
        date_of_birth: patient.date_of_birth != null ? moment(patient.date_of_birth).format('MM-DD-YYYY').toString() : '',
        sex: patient.sex,
        email: patient.email.toLowerCase().trim(),
        zipcode: patient.zipcode,
        phone_country_code: patient.phone_country_code,
        phone: patient.phone,
        height: patient.height != null ? patient.height : 0,
        height_2: patient.height_2 != null ? patient.height_2 : 0,
        weight: patient.weight != null ? patient.weight : 0,
        allergies: patient.allergies != null ? patient.allergies : '',
        medications: patient.medications != null ? patient.medications : '',
        medical_history: patient.medical_history != null ? patient.medical_history : '',
        surgical_history: patient.surgical_history != null ? patient.surgical_history : '',
        units: patient.units,
        timezone: patient.timezone,
        profile_image: patient.profile_image
    }

    return newPatient;
}

export function createRelevantLabObject(relevantLab: RelevantLab): any {
    let newRelevantLab = { ...relevantLab };
    return newRelevantLab;
}

export function createRelevantLab(relevantLab: any): RelevantLab {
    let newRevelantLab: RelevantLab = new RelevantLab();
    newRevelantLab = { ...relevantLab };
    return newRevelantLab;
}

export function createAppointmentLog(appointmentLog: any) {
    let newAppointmentLog: AppointmentLog = new AppointmentLog();
    newAppointmentLog = { ...appointmentLog }
    newAppointmentLog.created_at = moment().format('DD MMM YYYY hh:mm A').toString() || '';
    return newAppointmentLog;
}

export function createOrgLocation(orgLocation) {
    let newOrgLocation = new OrgLocation();
    newOrgLocation = { ...orgLocation };
    newOrgLocation.email = orgLocation.email.toLowerCase().trim();
    return newOrgLocation;
}

export function getUpdatedAt(time) {
    const now = moment();
    let updatedSince = '';

    // Time since last updated
    const updatedAtMoment = moment(Number(time))
    const durationUpdated = moment.duration(now.diff(updatedAtMoment));
    const minutesSinceUpdated = durationUpdated.asMinutes();
    const hoursSinceUpdated = durationUpdated.asHours();
    const daysSinceUpdated = durationUpdated.asDays();
    if (minutesSinceUpdated < 60) {
        updatedSince += Math.floor(minutesSinceUpdated).toString();
        updatedSince += ' Minutes ago';
    } else if (hoursSinceUpdated < 24) {
        updatedSince += Math.floor(hoursSinceUpdated).toString();
        if (updatedSince === '1') {
            updatedSince += ' Hour ago';
        } else {
            updatedSince += ' Hours ago';
        }
    } else {
        updatedSince += Math.floor(daysSinceUpdated).toString();
        if (updatedSince === '1') {
            updatedSince += ' Day ago';
        } else {
            updatedSince += ' Days ago';
        }
    }

    return updatedSince;
}

export function toTitleCase(str) {
    if (str.length == 0) return str;
    return str[0].toUpperCase() + str.substr(1);
}

export function getAge(dateString: string) {
    // Get interger value of age using date of birth supplied
    // Check if date string is empty or creates an invalid date
    if (dateString == null || dateString == '' || dateString == 'Invalid date') {
        return 'N/A';
    }
    let today = new Date();
    let birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export function getBMI(patient: any) {
    // Check if patient has height and weight
    if (patient.height == null || patient.weight == null || patient.height_2 == null) {
        return 'N/A';
    }
    // Check unit parameter for metric or imperial
    if (patient.unit == 'metric') {
        // convert height_2 to meters from cm
        let height_2 = Number(patient.height_2) / 100;
        let updatedHeight = Number(patient.height) + Number(height_2);

        return ((patient.weight / (updatedHeight * updatedHeight))).toFixed(2);
    } else {
        // convert height_2 to inches to feet
        let height_2 = Number(patient.height_2) / 12;
        let updatedHeight = Number(patient.height) + Number(height_2);
        // convert updatedHeight to inches
        updatedHeight = updatedHeight * 12;
        return ((patient.weight / (updatedHeight * updatedHeight)) * 703).toFixed(2);
    }
}

export function getHeight(patient: any) {
    if (patient.height == null || patient.height_2 == null) {
        return 'N/A';
    }
    if (patient.units == 'metric') {
        return `${patient.height}m ${patient.height_2}cm`;
    } else {
        return `${patient.height}ft ${patient.height_2}in`;
    }
}

export function getCreatedAt(time) {
    let timeSince = '';

    // Time since requested
    const now = moment();
    const createdAtMoment = moment(Number(time), 'x')

    const duration = moment.duration(now.diff(createdAtMoment));
    const minutesSince = duration.asMinutes();
    const hoursSince = duration.asHours();
    const daysSince = duration.asDays();

    if (minutesSince < 60) {
        timeSince += Math.floor(minutesSince).toString();
        timeSince += ' Minutes ago';
    } else if (hoursSince < 24) {
        timeSince += Math.floor(hoursSince).toString();
        if (timeSince === '1') {
            timeSince += ' Hour ago';
        } else {
            timeSince += ' Hours ago';
        }
    } else {
        timeSince += Math.floor(daysSince).toString();
        if (timeSince === '1') {
            timeSince += ' Day ago';
        } else {
            timeSince += ' Days ago';
        }
    }

    return timeSince;
}

export function createSubSpecialty(specialtyInfo: any) {
    let newSubSpecialty = new SubSpecialty();
    newSubSpecialty.id = specialtyInfo.sub_specialty_id;
    newSubSpecialty.sub_specialty_name = specialtyInfo.sub_specialty;
    newSubSpecialty.specialty_id = specialtyInfo.specialty_id;
    newSubSpecialty.specialty_name = specialtyInfo.specialty;
    newSubSpecialty.collection_id = specialtyInfo.id;
    newSubSpecialty.general_sub_specialty = specialtyInfo.general_sub_specialty;

    return newSubSpecialty;
}

export function createSubSpecialtyObject(specialty: Specialty, subSpecialty: SubSpecialty, expertID: string) {
    let newSubSpecialty = {
        specialty: specialty.specialty_name,
        specialty_id: specialty.id,
        sub_specialty: subSpecialty.sub_specialty_name,
        sub_specialty_id: subSpecialty.id,
        expert_id: expertID,
        general_sub_specialty: subSpecialty.general_sub_specialty
    }

    return newSubSpecialty;
}

export function createOrgLocationUserObject(location: any, doctorID: string) {
    const newLocation = {
        doctor_id: doctorID,
        org_location_id: location.id,
        status: 'invited',
        org_id: location.org_id
    }

    return newLocation;
}

export function createOrgLocationObject(orgLocation) {
    let newOrgLocation = { ...orgLocation }
    newOrgLocation.email = orgLocation.email.toLowerCase().trim();

    return newOrgLocation;
}

export function createNewOrgLocationObject(orgLocation) {
    let newOrgLocation = {
        location_name: orgLocation.location_name.trim(),
        location_type: orgLocation.location_type,
        contact_name: orgLocation.contact_name.toLowerCase().trim(),
        address_1: orgLocation.address_1.trim(),
        address_2: orgLocation.address_2 != null ? orgLocation.address_2.trim() : '',
        zipcode: orgLocation.zipcode.trim(),
        city: orgLocation.city.trim(),
        country: orgLocation.country,
        timezone: orgLocation.timezone,
        org_id: orgLocation.org_id,
        org_name: orgLocation.org_name.trim(),
        email: orgLocation.email.toLowerCase().trim(),
        phone: orgLocation.phone
    }

    return newOrgLocation;
}

export function createOrganization(organization) {
    let org = new Organization();
    org = { ...organization }

    return org;
}

export function createOrganizationObject(organization) {
    let org = { organization_name: organization.organization_name.trim() }
    return org;
}

export function getCountryCodes() {
    const countryCodes = [
        { "name": "Albania", "code": "AL" },
        { "name": "Åland Islands", "code": "AX" },
        { "name": "Algeria", "code": "DZ" },
        { "name": "American Samoa", "code": "AS" },
        { "name": "Andorra", "code": "AD" },
        { "name": "Angola", "code": "AO" },
        { "name": "Anguilla", "code": "AI" },
        { "name": "Antarctica", "code": "AQ" },
        { "name": "Antigua and Barbuda", "code": "AG" },
        { "name": "Argentina", "code": "AR" },
        { "name": "Armenia", "code": "AM" },
        { "name": "Aruba", "code": "AW" },
        { "name": "Australia", "code": "AU" },
        { "name": "Austria", "code": "AT" },
        { "name": "Azerbaijan", "code": "AZ" },
        { "name": "Bahamas (the)", "code": "BS" },
        { "name": "Bahrain", "code": "BH" },
        { "name": "Bangladesh", "code": "BD" },
        { "name": "Barbados", "code": "BB" },
        { "name": "Belarus", "code": "BY" },
        { "name": "Belgium", "code": "BE" },
        { "name": "Belize", "code": "BZ" },
        { "name": "Benin", "code": "BJ" },
        { "name": "Bermuda", "code": "BM" },
        { "name": "Bhutan", "code": "BT" },
        { "name": "Bolivia (Plurinational State of)", "code": "BO" },
        { "name": "Bonaire, Sint Eustatius and Saba", "code": "BQ" },
        { "name": "Bosnia and Herzegovina", "code": "BA" },
        { "name": "Botswana", "code": "BW" },
        { "name": "Bouvet Island", "code": "BV" },
        { "name": "Brazil", "code": "BR" },
        { "name": "British Indian Ocean Territory (the)", "code": "IO" },
        { "name": "Brunei Darussalam", "code": "BN" },
        { "name": "Bulgaria", "code": "BG" },
        { "name": "Burkina Faso", "code": "BF" },
        { "name": "Burundi", "code": "BI" },
        { "name": "Cabo Verde", "code": "CV" },
        { "name": "Cambodia", "code": "KH" },
        { "name": "Cameroon", "code": "CM" },
        { "name": "Canada", "code": "CA" },
        { "name": "Cayman Islands (the)", "code": "KY" },
        { "name": "Central African Republic (the)", "code": "CF" },
        { "name": "Chad", "code": "TD" },
        { "name": "Chile", "code": "CL" },
        { "name": "China", "code": "CN" },
        { "name": "Christmas Island", "code": "CX" },
        { "name": "Cocos (Keeling) Islands (the)", "code": "CC" },
        { "name": "Colombia", "code": "CO" },
        { "name": "Comoros (the)", "code": "KM" },
        { "name": "Congo (the Democratic Republic of the)", "code": "CD" },
        { "name": "Congo (the)", "code": "CG" },
        { "name": "Cook Islands (the)", "code": "CK" },
        { "name": "Costa Rica", "code": "CR" },
        { "name": "Croatia", "code": "HR" },
        { "name": "Cuba", "code": "CU" },
        { "name": "Curaçao", "code": "CW" },
        { "name": "Cyprus", "code": "CY" },
        { "name": "Czechia", "code": "CZ" },
        { "name": "Côte d'Ivoire", "code": "CI" },
        { "name": "Denmark", "code": "DK" },
        { "name": "Djibouti", "code": "DJ" },
        { "name": "Dominica", "code": "DM" },
        { "name": "Dominican Republic (the)", "code": "DO" },
        { "name": "Ecuador", "code": "EC" },
        { "name": "Egypt", "code": "EG" },
        { "name": "El Salvador", "code": "SV" },
        { "name": "Equatorial Guinea", "code": "GQ" },
        { "name": "Eritrea", "code": "ER" },
        { "name": "Estonia", "code": "EE" },
        { "name": "Eswatini", "code": "SZ" },
        { "name": "Ethiopia", "code": "ET" },
        { "name": "Falkland Islands (the) [Malvinas]", "code": "FK" },
        { "name": "Faroe Islands (the)", "code": "FO" },
        { "name": "Fiji", "code": "FJ" },
        { "name": "Finland", "code": "FI" },
        { "name": "France", "code": "FR" },
        { "name": "French Guiana", "code": "GF" },
        { "name": "French Polynesia", "code": "PF" },
        { "name": "French Southern Territories (the)", "code": "TF" },
        { "name": "Gabon", "code": "GA" },
        { "name": "Gambia (the)", "code": "GM" },
        { "name": "Georgia", "code": "GE" },
        { "name": "Germany", "code": "DE" },
        { "name": "Ghana", "code": "GH" },
        { "name": "Gibraltar", "code": "GI" },
        { "name": "Greece", "code": "GR" },
        { "name": "Greenland", "code": "GL" },
        { "name": "Grenada", "code": "GD" },
        { "name": "Guadeloupe", "code": "GP" },
        { "name": "Guam", "code": "GU" },
        { "name": "Guatemala", "code": "GT" },
        { "name": "Guernsey", "code": "GG" },
        { "name": "Guinea", "code": "GN" },
        { "name": "Guinea-Bissau", "code": "GW" },
        { "name": "Guyana", "code": "GY" },
        { "name": "Haiti", "code": "HT" },
        { "name": "Heard Island and McDonald Islands", "code": "HM" },
        { "name": "Holy See (the)", "code": "VA" },
        { "name": "Honduras", "code": "HN" },
        { "name": "Hong Kong", "code": "HK" },
        { "name": "Hungary", "code": "HU" },
        { "name": "Iceland", "code": "IS" },
        { "name": "India", "code": "IN" },
        { "name": "Indonesia", "code": "ID" },
        { "name": "Iran (Islamic Republic of)", "code": "IR" },
        { "name": "Iraq", "code": "IQ" },
        { "name": "Ireland", "code": "IE" },
        { "name": "Isle of Man", "code": "IM" },
        { "name": "Israel", "code": "IL" },
        { "name": "Italy", "code": "IT" },
        { "name": "Jamaica", "code": "JM" },
        { "name": "Japan", "code": "JP" },
        { "name": "Jersey", "code": "JE" },
        { "name": "Jordan", "code": "JO" },
        { "name": "Kazakhstan", "code": "KZ" },
        { "name": "Kenya", "code": "KE" },
        { "name": "Kiribati", "code": "KI" },
        { "name": "Korea (the Democratic People's Republic of)", "code": "KP" },
        { "name": "Korea (the Republic of)", "code": "KR" },
        { "name": "Kuwait", "code": "KW" },
        { "name": "Kyrgyzstan", "code": "KG" },
        { "name": "Lao People's Democratic Republic (the)", "code": "LA" },
        { "name": "Latvia", "code": "LV" },
        { "name": "Lebanon", "code": "LB" },
        { "name": "Lesotho", "code": "LS" },
        { "name": "Liberia", "code": "LR" },
        { "name": "Libya", "code": "LY" },
        { "name": "Liechtenstein", "code": "LI" },
        { "name": "Lithuania", "code": "LT" },
        { "name": "Luxembourg", "code": "LU" },
        { "name": "Macao", "code": "MO" },
        { "name": "Madagascar", "code": "MG" },
        { "name": "Malawi", "code": "MW" },
        { "name": "Malaysia", "code": "MY" },
        { "name": "Maldives", "code": "MV" },
        { "name": "Mali", "code": "ML" },
        { "name": "Malta", "code": "MT" },
        { "name": "Marshall Islands (the)", "code": "MH" },
        { "name": "Martinique", "code": "MQ" },
        { "name": "Mauritania", "code": "MR" },
        { "name": "Mauritius", "code": "MU" },
        { "name": "Mayotte", "code": "YT" },
        { "name": "Mexico", "code": "MX" },
        { "name": "Micronesia (Federated States of)", "code": "FM" },
        { "name": "Moldova (the Republic of)", "code": "MD" },
        { "name": "Monaco", "code": "MC" },
        { "name": "Mongolia", "code": "MN" },
        { "name": "Montenegro", "code": "ME" },
        { "name": "Montserrat", "code": "MS" },
        { "name": "Morocco", "code": "MA" },
        { "name": "Mozambique", "code": "MZ" },
        { "name": "Myanmar", "code": "MM" },
        { "name": "Namibia", "code": "NA" },
        { "name": "Nauru", "code": "NR" },
        { "name": "Nepal", "code": "NP" },
        { "name": "Netherlands (the)", "code": "NL" },
        { "name": "New Caledonia", "code": "NC" },
        { "name": "New Zealand", "code": "NZ" },
        { "name": "Nicaragua", "code": "NI" },
        { "name": "Niger (the)", "code": "NE" },
        { "name": "Nigeria", "code": "NG" },
        { "name": "Niue", "code": "NU" },
        { "name": "Norfolk Island", "code": "NF" },
        { "name": "Northern Mariana Islands (the)", "code": "MP" },
        { "name": "Norway", "code": "NO" },
        { "name": "Oman", "code": "OM" },
        { "name": "Pakistan", "code": "PK" },
        { "name": "Palau", "code": "PW" },
        { "name": "Palestine, State of", "code": "PS" },
        { "name": "Panama", "code": "PA" },
        { "name": "Papua New Guinea", "code": "PG" },
        { "name": "Paraguay", "code": "PY" },
        { "name": "Peru", "code": "PE" },
        { "name": "Philippines (the)", "code": "PH" },
        { "name": "Pitcairn", "code": "PN" },
        { "name": "Poland", "code": "PL" },
        { "name": "Portugal", "code": "PT" },
        { "name": "Puerto Rico", "code": "PR" },
        { "name": "Qatar", "code": "QA" },
        { "name": "Republic of North Macedonia", "code": "MK" },
        { "name": "Romania", "code": "RO" },
        { "name": "Russian Federation (the)", "code": "RU" },
        { "name": "Rwanda", "code": "RW" },
        { "name": "Réunion", "code": "RE" },
        { "name": "Saint Barthélemy", "code": "BL" },
        { "name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH" },
        { "name": "Saint Kitts and Nevis", "code": "KN" },
        { "name": "Saint Lucia", "code": "LC" },
        { "name": "Saint Martin (French part)", "code": "MF" },
        { "name": "Saint Pierre and Miquelon", "code": "PM" },
        { "name": "Saint Vincent and the Grenadines", "code": "VC" },
        { "name": "Samoa", "code": "WS" },
        { "name": "San Marino", "code": "SM" },
        { "name": "Sao Tome and Principe", "code": "ST" },
        { "name": "Saudi Arabia", "code": "SA" },
        { "name": "Senegal", "code": "SN" },
        { "name": "Serbia", "code": "RS" },
        { "name": "Seychelles", "code": "SC" },
        { "name": "Sierra Leone", "code": "SL" },
        { "name": "Singapore", "code": "SG" },
        { "name": "Sint Maarten (Dutch part)", "code": "SX" },
        { "name": "Slovakia", "code": "SK" },
        { "name": "Slovenia", "code": "SI" },
        { "name": "Solomon Islands", "code": "SB" },
        { "name": "Somalia", "code": "SO" },
        { "name": "South Africa", "code": "ZA" },
        { "name": "South Georgia and the South Sandwich Islands", "code": "GS" },
        { "name": "South Sudan", "code": "SS" },
        { "name": "Spain", "code": "ES" },
        { "name": "Sri Lanka", "code": "LK" },
        { "name": "Sudan (the)", "code": "SD" },
        { "name": "Suriname", "code": "SR" },
        { "name": "Svalbard and Jan Mayen", "code": "SJ" },
        { "name": "Sweden", "code": "SE" },
        { "name": "Switzerland", "code": "CH" },
        { "name": "Syrian Arab Republic", "code": "SY" },
        { "name": "Taiwan (Province of China)", "code": "TW" },
        { "name": "Tajikistan", "code": "TJ" },
        { "name": "Tanzania, United Republic of", "code": "TZ" },
        { "name": "Thailand", "code": "TH" },
        { "name": "Timor-Leste", "code": "TL" },
        { "name": "Togo", "code": "TG" },
        { "name": "Tokelau", "code": "TK" },
        { "name": "Tonga", "code": "TO" },
        { "name": "Trinidad and Tobago", "code": "TT" },
        { "name": "Tunisia", "code": "TN" },
        { "name": "Turkey", "code": "TR" },
        { "name": "Turkmenistan", "code": "TM" },
        { "name": "Turks and Caicos Islands (the)", "code": "TC" },
        { "name": "Tuvalu", "code": "TV" },
        { "name": "Uganda", "code": "UG" },
        { "name": "Ukraine", "code": "UA" },
        { "name": "United Arab Emirates (the)", "code": "AE" },
        { "name": "United Kingdom of Great Britain and Northern Ireland (the)", "code": "GB" },
        { "name": "United States Minor Outlying Islands (the)", "code": "UM" },
        { "name": "United States of America (the)", "code": "US" },
        { "name": "Uruguay", "code": "UY" },
        { "name": "Uzbekistan", "code": "UZ" },
        { "name": "Vanuatu", "code": "VU" },
        { "name": "Venezuela (Bolivarian Republic of)", "code": "VE" },
        { "name": "Viet Nam", "code": "VN" },
        { "name": "Virgin Islands (British)", "code": "VG" },
        { "name": "Virgin Islands (U.S.)", "code": "VI" },
        { "name": "Wallis and Futuna", "code": "WF" },
        { "name": "Western Sahara", "code": "EH" },
        { "name": "Yemen", "code": "YE" },
        { "name": "Zambia", "code": "ZM" },
        { "name": "Zimbabwe", "code": "ZW" }
    ]

    return countryCodes;
}

export function getExpertReminderMessages() {
    const messages = [
        'Expert message 1',
        'Expert message 2',
        'Expert message 3',
        'Expert message 4',
    ]

    return messages;
}

export function getDoctorReminderMessages() {
    const messages = [
        'Doctor message 1',
        'Doctor message 2',
        'Doctor message 3',
        'Doctor message 4',
    ]

    return messages;
}

export function getLocationReminderMessages() {
    const messages = [
        'Location message 1',
        'Location message 2',
        'Location message 3',
        'Location message 4',
    ]

    return messages;
}

export function getSendToAllMessages() {
    const messages = [
        'Sent to all message 1',
        'Sent to all message 2',
        'Sent to all message 3',
        'Sent to all message 4',
    ]

    return messages;
}

export function getReplacementExpertMessage() {
    const message = 'You have been added to an appointment. Please see World Top Docs for details.'
    return message;
}

export function getReplacedExpertMessage() {
    const message = 'You have been removed from an appointment. No further action needed.'
    return message;
}

export function getClosedAppointmentMessage() {
    const message = 'Your appointment has been closed by an admin. No further action needed.'
    return message;
}

export function getCanceledAppointmentMessage() {
    const message = 'Your appointment has been canceled by an admin. No further action needed.'
    return message;
}

export function createAdminNote(adminNotes: any) {
    let newAdminNote: AdminNote = new AdminNote();
    newAdminNote = { ...adminNotes }
    newAdminNote.created_at = moment().format('DD MMM YYYY hh:mm A').toString();
    return newAdminNote;
}

export function getSendReminderAll() {
    return 'You have an upcoming appointment'
}

export function getYouHaveBeenReplacedCoverage() {
    return `You have been removed from coverage`
}

export function getYouHaveBeenAddedCoverage() {
    return `You have been added to coverage`
}


export function combineAppointmentInformation(
    selectedPatient: Patient,
    expert: Expert,
    chiefComplaint: string,
    history: string,
    appointmentInfo: Appointment,
    selectedOrganizationLocation: OrgLocation,
    currentUser: any): Appointment {

    // Save appointment information from different sources
    let appointment = new Appointment;
    // Get patient information
    appointment.patient_first_name = selectedPatient.first_name;
    appointment.patient_last_name = selectedPatient.last_name;
    appointment.patient_id = selectedPatient.id;
    // Get expert information
    appointment.expert_first_name = expert.first_name;
    appointment.expert_last_name = expert.last_name;
    appointment.expert_id = expert.id;
    // Get appointment details
    appointment.chief_complaint = chiefComplaint;
    appointment.history_of_illness = history;
    appointment.urgent_notes = appointmentInfo.urgent_notes;
    // Get correct speciality information
    if (appointmentInfo.specialty.id == '0') {
        let newSpecialty = new Specialty();
        newSpecialty.id = appointmentInfo.sub_specialty.specialty_id;
        newSpecialty.specialty_name = appointmentInfo.sub_specialty.specialty_name;
        appointment.specialty = newSpecialty;
    } else {
        appointment.specialty = appointmentInfo.specialty;
    }
    appointment.sub_specialty = appointmentInfo.sub_specialty;
    // Relevant lab information
    appointment.relevant_labs = appointmentInfo.relevant_labs;
    // Other appointment information
    appointment.org_location_id = selectedOrganizationLocation.id;
    appointment.org_location_name = selectedOrganizationLocation.location_name;
    appointment.user_id = currentUser.user_id;
    appointment.doctor_id = currentUser.id;
    appointment.doctor_first_name = currentUser.first_name;
    appointment.doctor_last_name = currentUser.last_name;
    appointment.expert_join_time = appointmentInfo.expert_join_time;
    appointment.hospital_join_time = appointmentInfo.hospital_join_time;
    appointment.messages = appointmentInfo.messages;
    appointment.date_closed = appointmentInfo.date_closed;
    appointment.review_addressed = appointmentInfo.review_addressed;
    appointment.received_requested_info = appointmentInfo.received_requested_info;
    appointment.expectation_resolved = appointmentInfo.expectation_resolved;
    appointment.expectation = appointmentInfo.expectation;
    appointment.admin_resolution_notes = appointmentInfo.admin_resolution_notes;
    appointment.consultation = appointmentInfo.consultation;
    appointment.confirmed = appointmentInfo.confirmed;
    appointment.urgent = appointmentInfo.urgent;
    appointment.zoom_join = appointmentInfo.zoom_join;
    appointment.zoom_start = appointmentInfo.zoom_start;
    appointment.zoom_video_url = appointmentInfo.zoom_video_url;
    appointment.zoom_meeting_id = appointmentInfo.zoom_meeting_id;
    appointment.zoom_meeting_password = appointmentInfo.zoom_meeting_password;
    appointment.is_custom_time = appointmentInfo.is_custom_time;
    appointment.expert_request = appointmentInfo.expert_request;
    appointment.info_requested = appointmentInfo.info_requested;
    appointment.rescheduled = appointmentInfo.rescheduled;
    appointment.reschedule_requested = appointmentInfo.reschedule_requested;
    appointment.urgent_confirmed = appointmentInfo.urgent_confirmed;
    appointment.canceled = appointmentInfo.canceled;
    appointment.session_invites_sent = appointmentInfo.session_invites_sent;
    appointment.experts_invited = appointmentInfo.experts_invited;
    appointment.created_at = appointmentInfo.created_at;
    appointment.updated_at = appointmentInfo.updated_at;
    appointment.needs_confirmation_by = appointmentInfo.needs_confirmation_by;
    appointment.consult_notes = appointmentInfo.consult_notes;
    appointment.expert_notes = appointmentInfo.expert_notes;
    appointment.general_consult_notes = appointmentInfo.general_consult_notes;
    appointment.appointment_date = appointmentInfo.appointment_date;
    appointment.appointment_date_timestamp = appointmentInfo.appointment_date_timestamp;
    appointment.appointment_date_id = appointmentInfo.appointment_date_id;
    appointment.joined = false;
    appointment.expert_join_time = null;
    appointment.new_lab = appointmentInfo.new_lab;
    appointment.new_expert_message = appointmentInfo.new_expert_message;
    appointment.new_doctor_message = appointmentInfo.new_doctor_message;

    return appointment
}

export function getTimeZones() {
    const tzStrings = [
        { "label": "(GMT-12:00) International Date Line West", "value": "Etc/GMT+12" },
        { "label": "(GMT-11:00) Midway Island, Samoa", "value": "Pacific/Midway" },
        { "label": "(GMT-10:00) Hawaii", "value": "Pacific/Honolulu" },
        { "label": "(GMT-09:00) Alaska", "value": "US/Alaska" },
        { "label": "(GMT-08:00) Pacific Time (US & Canada)", "value": "America/Los_Angeles" },
        { "label": "(GMT-08:00) Tijuana, Baja California", "value": "America/Tijuana" },
        { "label": "(GMT-07:00) Arizona", "value": "US/Arizona" },
        { "label": "(GMT-07:00) Chihuahua, La Paz, Mazatlan", "value": "America/Chihuahua" },
        { "label": "(GMT-07:00) Mountain Time (US & Canada)", "value": "US/Mountain" },
        { "label": "(GMT-06:00) Central America", "value": "America/Managua" },
        { "label": "(GMT-06:00) Central Time (US & Canada)", "value": "US/Central" },
        { "label": "(GMT-06:00) Guadalajara, Mexico City, Monterrey", "value": "America/Mexico_City" },
        { "label": "(GMT-06:00) Saskatchewan", "value": "Canada/Saskatchewan" },
        { "label": "(GMT-05:00) Bogota, Lima, Quito, Rio Branco", "value": "America/Bogota" },
        { "label": "(GMT-05:00) Eastern Time (US & Canada)", "value": "US/Eastern" },
        { "label": "(GMT-05:00) Indiana (East)", "value": "US/East-Indiana" },
        { "label": "(GMT-04:00) Atlantic Time (Canada)", "value": "Canada/Atlantic" },
        { "label": "(GMT-04:00) Caracas, La Paz", "value": "America/Caracas" },
        { "label": "(GMT-04:00) Manaus", "value": "America/Manaus" },
        { "label": "(GMT-04:00) Santiago", "value": "America/Santiago" },
        { "label": "(GMT-03:30) Newfoundland", "value": "Canada/Newfoundland" },
        { "label": "(GMT-03:00) Brasilia", "value": "America/Sao_Paulo" },
        { "label": "(GMT-03:00) Buenos Aires, Georgetown", "value": "America/Argentina/Buenos_Aires" },
        { "label": "(GMT-03:00) Greenland", "value": "America/Godthab" },
        { "label": "(GMT-03:00) Montevideo", "value": "America/Montevideo" },
        { "label": "(GMT-02:00) Mid-Atlantic", "value": "America/Noronha" },
        { "label": "(GMT-01:00) Cape Verde Is.", "value": "Atlantic/Cape_Verde" },
        { "label": "(GMT-01:00) Azores", "value": "Atlantic/Azores" },
        { "label": "(GMT+00:00) Casablanca, Monrovia, Reykjavik", "value": "Africa/Casablanca" },
        { "label": "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London", "value": "Etc/Greenwich" },
        { "label": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", "value": "Europe/Amsterdam" },
        { "label": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", "value": "Europe/Belgrade" },
        { "label": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris", "value": "Europe/Brussels" },
        { "label": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb", "value": "Europe/Sarajevo" },
        { "label": "(GMT+01:00) West Central Africa", "value": "Africa/Lagos" },
        { "label": "(GMT+02:00) Amman", "value": "Asia/Amman" },
        { "label": "(GMT+02:00) Athens, Bucharest, Istanbul", "value": "Europe/Athens" },
        { "label": "(GMT+02:00) Beirut", "value": "Asia/Beirut" },
        { "label": "(GMT+02:00) Cairo", "value": "Africa/Cairo" },
        { "label": "(GMT+02:00) Harare, Pretoria", "value": "Africa/Harare" },
        { "label": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", "value": "Europe/Helsinki" },
        { "label": "(GMT+02:00) Jerusalem", "value": "Asia/Jerusalem" },
        { "label": "(GMT+02:00) Minsk", "value": "Europe/Minsk" },
        { "label": "(GMT+02:00) Windhoek", "value": "Africa/Windhoek" },
        { "label": "(GMT+03:00) Kuwait, Riyadh, Baghdad", "value": "Asia/Kuwait" },
        { "label": "(GMT+03:00) Moscow, St. Petersburg, Volgograd", "value": "Europe/Moscow" },
        { "label": "(GMT+03:00) Nairobi", "value": "Africa/Nairobi" },
        { "label": "(GMT+03:00) Tbilisi", "value": "Asia/Tbilisi" },
        { "label": "(GMT+03:30) Tehran", "value": "Asia/Tehran" },
        { "label": "(GMT+04:00) Abu Dhabi, Muscat", "value": "Asia/Muscat" },
        { "label": "(GMT+04:00) Baku", "value": "Asia/Baku" },
        { "label": "(GMT+04:00) Yerevan", "value": "Asia/Yerevan" },
        { "label": "(GMT+04:30) Kabul", "value": "Asia/Kabul" },
        { "label": "(GMT+05:00) Yekaterinburg", "value": "Asia/Yekaterinburg" },
        { "label": "(GMT+05:00) Islamabad, Karachi, Tashkent", "value": "Asia/Karachi" },
        { "label": "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi", "value": "Asia/Calcutta" },
        { "label": "(GMT+05:30) Sri Jayawardenapura", "value": "Asia/Calcutta" },
        { "label": "(GMT+05:45) Kathmandu", "value": "Asia/Katmandu" },
        { "label": "(GMT+06:00) Almaty, Novosibirsk", "value": "Asia/Almaty" },
        { "label": "(GMT+06:00) Astana, Dhaka", "value": "Asia/Dhaka" },
        { "label": "(GMT+06:30) Yangon (Rangoon)", "value": "Asia/Rangoon" },
        { "label": "(GMT+07:00) Bangkok, Hanoi, Jakarta", "value": "Asia/Bangkok" },
        { "label": "(GMT+07:00) Krasnoyarsk", "value": "Asia/Krasnoyarsk" },
        { "label": "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi", "value": "Asia/Hong_Kong" },
        { "label": "(GMT+08:00) Kuala Lumpur, Singapore", "value": "Asia/Kuala_Lumpur" },
        { "label": "(GMT+08:00) Irkutsk, Ulaan Bataar", "value": "Asia/Irkutsk" },
        { "label": "(GMT+08:00) Perth", "value": "Australia/Perth" },
        { "label": "(GMT+08:00) Taipei", "value": "Asia/Taipei" },
        { "label": "(GMT+09:00) Osaka, Sapporo, Tokyo", "value": "Asia/Tokyo" },
        { "label": "(GMT+09:00) Seoul", "value": "Asia/Seoul" },
        { "label": "(GMT+09:00) Yakutsk", "value": "Asia/Yakutsk" },
        { "label": "(GMT+09:30) Adelaide", "value": "Australia/Adelaide" },
        { "label": "(GMT+09:30) Darwin", "value": "Australia/Darwin" },
        { "label": "(GMT+10:00) Brisbane", "value": "Australia/Brisbane" },
        { "label": "(GMT+10:00) Canberra, Melbourne, Sydney", "value": "Australia/Canberra" },
        { "label": "(GMT+10:00) Hobart", "value": "Australia/Hobart" },
        { "label": "(GMT+10:00) Guam, Port Moresby", "value": "Pacific/Guam" },
        { "label": "(GMT+10:00) Vladivostok", "value": "Asia/Vladivostok" },
        { "label": "(GMT+11:00) Magadan, Solomon Is., New Caledonia", "value": "Asia/Magadan" },
        { "label": "(GMT+12:00) Auckland, Wellington", "value": "Pacific/Auckland" },
        { "label": "(GMT+12:00) Fiji, Kamchatka, Marshall Is.", "value": "Pacific/Fiji" },
        { "label": "(GMT+13:00) Nuku'alofa", "value": "Pacific/Tongatapu" }
    ]

    return tzStrings;
}

export function getDayString(day: number) {
    switch (day) {
        case 0:
            return "Sun";
        case 1:
            return "Mon";
        case 2:
            return "Tue";
        case 3:
            return "Wed";
        case 4:
            return "Thu";
        case 5:
            return "Fri";
        case 6:
            return "Sat";
    }
}

export function getMonthString(month: number) {
    switch (month) {
        case 0:
            return "JAN";
        case 1:
            return "FEB";
        case 2:
            return "MAR";
        case 3:
            return "APR";
        case 4:
            return "MAY";
        case 5:
            return "JUN";
        case 6:
            return "JUL";
        case 7:
            return "AUG";
        case 8:
            return "SEP";
        case 9:
            return "OCT";
        case 10:
            return "NOV";
        case 11:
            return "DEC";

    }
}

export function getLongMonthString(month: number) {
    switch (month) {
        case 0:
            return "January";
        case 1:
            return "February";
        case 2:
            return "March";
        case 3:
            return "April";
        case 4:
            return "May";
        case 5:
            return "June";
        case 6:
            return "July";
        case 7:
            return "August";
        case 8:
            return "September";
        case 9:
            return "October";
        case 10:
            return "November";
        case 11:
            return "December";
    }
}
